module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "info text-center"
  }, [_c('h4', {
    class: 'text-uppercase ' + (_vm.info.spinner ? '--searching' : (_vm.info.success ? '--success' : '--warning'))
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.info.spinner),
      expression: "!info.spinner"
    }],
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.info.title) + "\n      ")]), _vm._v(" "), (_vm.info.spinner) ? _c('h5', [_c('i', {
    staticClass: "custom-loading-color fa fa-spinner fa-spin fa-4x fa-fw"
  })]) : _c('h5', [_vm._v("\n        " + _vm._s(_vm.info.msg) + "\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.info.spinner),
      expression: "!info.spinner"
    }],
    class: 'btn btn-' + (_vm.info.success ? 'success' : 'danger'),
    attrs: {
      "id": "info-button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Regresar")])])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "dismiss-button",
      "data-dismiss": "modal"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46569db3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/Loading.vue
// module id = 1698
// module chunks = 6